import { render } from "./ButtonLoader.vue?vue&type=template&id=f43084b6&scoped=true"
import script from "./ButtonLoader.vue?vue&type=script&lang=js"
export * from "./ButtonLoader.vue?vue&type=script&lang=js"

import "./ButtonLoader.vue?vue&type=style&index=0&id=f43084b6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f43084b6"

export default script